import React, {ReactElement} from 'react';
// import Workspace from '../components/workspace/Workspace.component';
// import Workspace from '../components/workspace/Workspace.component.updated';
import WorkspaceToggleWrapper from '../components/workspace/WorkspaceToggleWrapper';
import 'split-pane-react/esm/themes/default.css';

export default function WorkspacePage(): ReactElement {
    // Feature flag to enable/disable the explorer toggle
    // Set to false to use the production explorer without toggle
    const ENABLE_EXPLORER_TOGGLE = true;

    // Authentication is now handled by ProtectedRoute wrapper in App.tsx
    // No need to check auth here - if we're rendering, we're authenticated

    // Use toggle wrapper if enabled, otherwise use the new explorer directly
    if (ENABLE_EXPLORER_TOGGLE) {
        return <WorkspaceToggleWrapper />;
    }
    
    // When ready for production, set ENABLE_EXPLORER_TOGGLE to false
    // and uncomment the line below:
    // return <Workspace />; // This would be the renamed Workspace.component.updated.tsx
    
    // For now, if toggle is disabled, use the new explorer
    const Workspace = require('../components/workspace/Workspace.component.updated').default;
    return <Workspace />;
}